import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../../css/BalanceSheet.css'; // Optional for custom styles if needed
import { API_URL, ENDPOINTS } from '../../constants/api';

const BalanceSheet = () => {
  const [accountData, setAccountData] = useState([]);
  const [totals, setTotals] = useState({
    assets: 0,
    liabilities: 0,
    equity: 0,
  });

  useEffect(() => {
    // Fetch account data from API
    axios
      .get(`${API_URL}/${ENDPOINTS.SYS}/balancesheet`) // Replace with your API endpoint
      .then((response) => {
        setAccountData(response.data);
        calculateTotals(response.data);
      })
      .catch((error) => {
        console.error('Error fetching account data:', error);
      });
  }, []);

  // Calculate totals for balance sheet sections
  const calculateTotals = (data) => {
    const totals = data.reduce(
      (acc, item) => {
        if (item.account_type === 'Asset') acc.assets += item.account_balance;
        if (item.account_type === 'Liability')
          acc.liabilities += item.account_balance;
        if (item.account_type === 'Equity') acc.equity += item.account_balance;
        return acc;
      },
      { assets: 0, liabilities: 0, equity: 0 }
    );
    setTotals(totals);
  };

  return (
    <div className="container my-5">
      {/* Header Section */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h1 className="display-6">Balance Sheet</h1>
          <p className="text-muted">Ancaam Meat Company</p>
          <p>{new Date().toLocaleDateString()}</p>
        </div>
        <img
          src="/logo.png"
          alt="Company Logo"
          className="img-fluid"
          style={{ maxHeight: '80px' }}
        />
      </div>

      {/* Balance Sheet Sections */}
      <div className="row">
        {/* Assets Section */}
        <div className="col-md-6">
          <h2 className="text-primary">Assets</h2>
          <ul className="list-group mb-3">
            {accountData
              .filter((item) => item.account_type === 'Asset')
              .map((item) => (
                <li
                  key={item.account_id}
                  className="list-group-item d-flex justify-content-between align-items-center"
                >
                  {item.account_name}
                  <span className="badge bg-primary">
                    {item.account_balance.toLocaleString()} USD
                  </span>
                </li>
              ))}
          </ul>
          <div className="alert alert-primary d-flex justify-content-between">
            <strong>Total Assets</strong>
            <span>{totals.assets.toLocaleString()} USD</span>
          </div>
        </div>

        {/* Liabilities and Equity Section */}
        <div className="col-md-6">
          <h2 className="text-danger">Liabilities & Equity</h2>

          {/* Liabilities */}
          <h4 className="mt-3">Liabilities</h4>
          <ul className="list-group mb-3">
            {accountData
              .filter((item) => item.account_type === 'Liability')
              .map((item) => (
                <li
                  key={item.account_id}
                  className="list-group-item d-flex justify-content-between align-items-center"
                >
                  {item.account_name}
                  <span className="badge bg-danger">
                    {item.account_balance.toLocaleString()} USD
                  </span>
                </li>
              ))}
          </ul>

          <div className="alert alert-danger d-flex justify-content-between">
            <strong>Total Liabilities</strong>
            <span>{totals.liabilities.toLocaleString()} USD</span>
          </div>

          {/* Equity */}
          <h4 className="mt-3">Equity</h4>
          <ul className="list-group mb-3">
            {accountData
              .filter((item) => item.account_type === 'Equity')
              .map((item) => (
                <li
                  key={item.account_id}
                  className="list-group-item d-flex justify-content-between align-items-center"
                >
                  {item.account_name}
                  <span className="badge bg-success">
                    {item.account_balance.toLocaleString()} USD
                  </span>
                </li>
              ))}
          </ul>

          <div className="alert alert-success d-flex justify-content-between">
            <strong>Total Equity</strong>
            <span>{totals.equity.toLocaleString()} USD</span>
          </div>
        </div>
      </div>

      {/* Balance Check */}
      <div className="alert alert-info mt-4">
        <strong>
          Total Assets ({totals.assets.toLocaleString()} USD) = Liabilities +
          Equity ({(totals.liabilities + totals.equity).toLocaleString()} USD)
        </strong>
      </div>
    </div>
  );
};

export default BalanceSheet;
